import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { FormAction, formValueSelector } from 'redux-form'

//@ts-ignore
import LKButton from 'shared/LKButton'

const ReverseButton: FC<{
  FormName: string
  change: (key: string, value: any) => FormAction
  disabled?: boolean
}> = ({ FormName, change, disabled }) => {
  const valueSelector = formValueSelector(FormName)

  const selectByName = (name?: string, defaultValue?: any) => (state) => valueSelector(state, name) || defaultValue

  const debitID: number = useSelector(selectByName('DebitAccID', ''))
  const debitHash: string = useSelector(selectByName('DebitAccHash', ''))
  const debit: number = useSelector(selectByName('DebitAccNo', ''))
  const debitTitle: string = useSelector(selectByName('DebitTitleUNI', ''))
  const debitBalance: number = useSelector(selectByName('DebitAccBalance', 0))
  const debitChosenAccNo: string = useSelector(selectByName('DebitChosenAccNo', ''))
  const creditID: number = useSelector(selectByName('CreditAccID', ''))
  const creditHash: string = useSelector(selectByName('CreditAccHash', ''))
  const credit: number = useSelector(selectByName('CreditAccNo', ''))
  const creditTitle: string = useSelector(selectByName('CreditTitleUNI', ''))
  const creditBalance: number = useSelector(selectByName('CreditAccBalance', 0))
  const creditChosenAccNo: string = useSelector(selectByName('CreditChosenAccNo', ''))
  const debitCCY: string = useSelector(selectByName('debitCCY'))
  const creditCCY: string = useSelector(selectByName('creditCCY'))
  const ccyBuyRate: string = useSelector(selectByName('ccyBuyRate'))
  const ccySellRate: string = useSelector(selectByName('ccySellRate'))

  function handleClick() {
    change('DebitAccNo', credit)
    change('DebitTitleUNI', creditTitle)
    change('DebitAccID', creditID)
    change('DebitAccHash', creditHash)
    change('DebitAccBalance', creditBalance)
    change('DebitChosenAccNo', creditChosenAccNo)

    change('CreditAccNo', debit)
    change('CreditTitleUNI', debitTitle)
    change('CreditAccID', debitID)
    change('CreditAccHash', debitHash)
    change('CreditAccBalance', debitBalance)
    change('CreditChosenAccNo', debitChosenAccNo)

    change('debitCCY', creditCCY)
    change('creditCCY', debitCCY)
    change('ccyBuyRate', ccySellRate)
    change('ccySellRate', ccyBuyRate)
    change('alreadyDefinedRates', '1')
  }

  return <LKButton disabled={disabled} onClick={handleClick} alias="reverse" />
}

export default ReverseButton
